if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';
        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        const productUrl = opener.getAttribute('data-product-url');
        const jsonUrl = productUrl.split('?')[0] + '.json';

        // Fetch page HTML and product JSON in parallel
        Promise.all([
          fetch(productUrl).then(r => r.text()),
          fetch(jsonUrl).then(r => r.json()).catch(() => null)
        ])
          .then(([responseText, productData]) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);

            // Inject price into the price container BEFORE inserting into DOM
            if (productData && productData.product) {
              this.razzInjectPriceIntoElement(productElement, productData.product);
            }

            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      razzInjectPriceIntoElement(productElement, product) {
        const priceDiv = productElement.querySelector('[id^="price-"]');
        if (!priceDiv) return;

        const variant = product.variants[0];
        const priceNum = parseFloat(variant.price);
        const compareNum = variant.compare_at_price ? parseFloat(variant.compare_at_price) : null;
        const priceVaries = product.variants.some(v => parseFloat(v.price) !== priceNum);
        const prefix = priceVaries ? '<span class="price-item__from">From </span>' : '';

        const fmt = (p) => {
          const dollars = Math.floor(p);
          const cents = Math.round((p - dollars) * 100);
          return cents > 0
            ? '$' + dollars + '.' + String(cents).padStart(2, '0')
            : '$' + dollars;
        };

        let inner = '';
        if (compareNum && compareNum > priceNum) {
          inner = `<div class="price__container">
            <div class="price__sale">
              <span class="price-item price-item--regular"><s><bdi>${fmt(compareNum)}</bdi></s></span>
              <span class="price-item price-item--sale">${prefix}<bdi>${fmt(priceNum)}</bdi></span>
            </div>
          </div>`;
          priceDiv.classList.add('price--on-sale');
        } else {
          inner = `<div class="price__container">
            <div class="price__regular">
              <span class="price-item price-item--regular">${prefix}<bdi>${fmt(priceNum)}</bdi></span>
            </div>
          </div>`;
        }

        priceDiv.innerHTML = inner;
        priceDiv.classList.remove('hidden');
        priceDiv.classList.add('price');
        priceDiv.style.display = 'block';
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;
        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });
        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;
        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
